import Color from '@styles/Color';
import React from 'react';
import styled from 'styled-components';

const NotificationContainer = styled.div<{ unreadNumber?: string }>`
  position: absolute;
  top: 2px;
  right: ${({ unreadNumber }) =>
    unreadNumber && `calc(1px - ${7 * (unreadNumber.length - 1)}px)`};
  background: ${Color.RED_6};
  border-radius: 100px;
  width: ${({ unreadNumber }) =>
    unreadNumber && `calc(19px + ${7 * (unreadNumber.length - 1)}px)`};
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 1px;
  padding-bottom: 1px;
  pointer-events: none;
`;

type Props = {
  unreadNumber: number;
  style?: any;
  type?: 'number' | 'new';
};

function NotiBadge({ unreadNumber, style, type = 'number' }: Props) {
  const number = unreadNumber > 99 ? '99+' : String(unreadNumber);

  if (unreadNumber > 0 && type === 'number') {
    return (
      <>
        <NotificationContainer unreadNumber={number} style={style}>
          <strong style={{ color: '#fff', fontSize: 12 }}>{number}</strong>
        </NotificationContainer>
      </>
    );
  } else if (type === 'new') {
    return (
      <>
        <NotificationContainer unreadNumber={number} style={style}>
          <strong style={{ color: '#fff', fontSize: 12 }}>N</strong>
        </NotificationContainer>
      </>
    );
  } else return null;
}

export default NotiBadge;
